module.exports = __webpack_public_path__ + "img/default_unstabilized.78e50f68.png";